import { RiSearch2Fill } from "react-icons/ri";

/* eslint-disable react/prop-types */
export default function EventSearchInput({
    onSearch,
    query,
    setQuery,
    placeholder = "Buscar eventos...",
}) {
    return (
        <form onSubmit={onSearch} className="mx-auto my-8 w-full max-w-2xl">
            <label htmlFor="event-search" className="sr-only">
                Buscar eventos
            </label>
            <div className="group relative flex items-center rounded-xl border border-zinc-700/80 bg-zinc-900/70 shadow-[0_10px_30px_rgba(0,0,0,0.35)] backdrop-blur-sm transition-colors focus-within:border-rose-400/70">
            <input
                id="event-search"
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder={placeholder}
                className="h-12 w-full rounded-xl bg-transparent pl-4 pr-14 text-sm text-zinc-100 placeholder:text-zinc-400 focus:outline-none sm:h-14 sm:text-base"
            />
            <button
                type="submit"
                className="absolute right-1.5 flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-r from-rose-500 to-rose-600 text-white transition-transform hover:scale-105 sm:right-2 sm:h-10 sm:w-10"
                aria-label="Buscar eventos"
            >
                <RiSearch2Fill className="text-lg" />
            </button>
            </div>
        </form>
    );
}
